import { getToken } from "@/utils/auth.js";
import { login } from "@/api/login.js";
import { getUrlParam } from "./url.js";
import { getUserByWxId } from "@/api/user.js";
import qs from "qs";
import { Toast, Dialog } from "vant";
import router from "@/router";

export function getWXCodeUrl(redirect_uri, state) {
  return (
    `https://open.weixin.qq.com/connect/oauth2/authorize` +
    `?appid=${process.env.VUE_APP_WX_APPID}` +
    `&redirect_uri=${redirect_uri}` +
    `&response_type=code` +
    `&scope=snsapi_base` +
    `&state=${state}` +
    `#wechat_redirect`
  );
}
export function getWXCode(state) {
  const code = getUrlParam("code"); // 获取当前页面地址中的code参数的值
  // 如果code是''，说明还没有授权，访问下面连接，用户同意授权，获取code
  if (code === "" || code == null) {
    const WXCodeUrl = getWXCodeUrl(process.env.VUE_APP_DOMAIN, state);
    console.log("WXCodeUrl:" + WXCodeUrl);
    window.location.href = WXCodeUrl;
  }
}
export function getWXCodeOrToRegister(route, func) {
  let openId = getToken();
  if (
    openId == undefined ||
    openId == null ||
    openId === "" ||
    openId === "null"
  ) {
    // openId为空，调用微信接口获取CODE
    getWXCode(route.path);
  } else {
    // openId不为空
    getUserByWxId(openId)
      .then(res => {
        console.log(res);
        if (res.data.code === 200) {
          const user = res.data.results;
          console.log(user);
          if (user == null) {
            // 未注册
            Dialog.alert({
              title: "未注册",
              message: "未注册，现在去注册"
            }).then(() => {
              router.push({ name: "Register" });
            });
          } else {
            // 已注册
            const data = {
              wxId: openId
            };
            login(qs.stringify(data))
              .then(res2 => {
                if (res2.data.code === 200) {
                  func(openId);
                }
              })
              .catch(error => {
                console.error(error);
                Toast.fail("登录失败！");
              });
          }
        } else {
          Toast.fail("请求失败");
        }
      })
      .catch(err => {
        console.log(err);
      });
  }
}
